<template>
  <div v-if="getData?.items" class="product-slider-revised">
    <ProductSliderTitle v-if="getData.messages && getData.messages.title">
      {{ getData.messages.title }}
    </ProductSliderTitle>

    <DefSlider :settings="settings" :nav="screenWidth >= 992" :pagination="true">
      <div v-for="item in getData.items" class="swiper-slide">
        <SliderCard :result="item" />
      </div>
    </DefSlider>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProductSliderTitle from '@components/Product/sliders/ProductSliderTitle.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import SliderCard from '@components/card/SliderCard/SliderCard.vue';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'ProductSliderRevised',
  components: { SliderCard, DefSlider, ProductSliderTitle },
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
      settings: {
        slidesPerView: 1.4,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 2.4,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      viewd: ({ catalog }) => catalog?.data?.catalogSectionList?.viewed,
    }),
    getData() {
      return this.result || this.viewd;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-slider-revised {
  margin-bottom: 40px;
  @include point-md {
    margin-bottom: 60px;
  }
  @include point-lg {
    margin-bottom: 80px;
  }
  :deep(.def-slider__prev) {
    left: 0;
    transform: translate(-50%, -50%);
  }
  :deep(.def-slider__next) {
    right: 0;
    transform: translate(50%, -50%);
  }
}
</style>
